// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7n-0";
export var startPickingButton = "_7n-1";